module.exports = __webpack_public_path__ + "img/1358122253.2511aac2.jpg";